<app-enrollment-banner></app-enrollment-banner>
<div class="container px-5 pt-5 mt-md-3">
  <div class="row mb-3">
    <div class="col-12">
      <button (click)="goBackToDashboard()" class="btn btn-outline-success btn-lg bg-white go-back-btn" type="button">
        {{ backButtonTranslation | translate }}
      </button>
    </div>
  </div>
  @if (summary$ | async; as summary) {
  <div class="row">
    <div class="col-12">
      <h1>{{translationPrefix + '.content.heading' | translate}}</h1>
    </div>
  </div>
  <div class="row">
    <div class="col-12">{{translationPrefix + '.content.disclaimer' | translate: summary.transaction}}</div>
  </div>
  <div class="row mt-3">
    <div [innerHTML]="translationPrefix + '.content.transactionInfo' | translate: summary.transaction" class="col-12"></div>
  </div>
  @if (summary.hra?.hraUrl) {
  <div class="row mt-3" *featureFlag="FF_ENABLE_HRA_LINK">
    <div class="col-12">
      <span [innerHTML]="translationPrefix + '.content.hraLink' | translate"></span>
      <a [href]="summary.hra.hraUrl" class="text-decoration-underline" rel="noopener noreferrer" target="_blank"
        >&nbsp;{{ summary.hra.hraUrl }}</a
      >
    </div>
  </div>
  } @if (showBlueButton) {
  <div class="row mt-3">
    <div [innerHTML]="translationPrefix + '.content.blueButton' | translate: summary.blueButton" class="col-12"></div>
  </div>
  <div class="row mt-4 justify-content-center">
    <div class="col-xs-12 col-sm-6 col-md-4">
      <button (click)="blueButtonClick()" class="btn btn-info btn-lg btn-block" type="button">
        {{ 'common.buttonLabels.blueButton' | translate }}
      </button>
    </div>
  </div>
  <div class="row mt-4 mb-4">
    <div [innerHTML]="translationPrefix + '.content.blueButtonDisclaimer' | translate: summary.blueButton" class="col-12"></div>
  </div>
  }
  <app-summary [summary]="summary" [applicationRevision]="summary.revision"></app-summary>
  <div class="container pt-5">
    <div class="row">
      <div class="col-12 p-0">
        <p>{{ summary.materialId }}</p>
      </div>
    </div>
  </div>
  }
</div>
